
  import userController from '/home/builduser/work/d7a4e0f42d2e4b8d/packages/wixstores-client-product-page/src/components/ProductPage/controller.ts';
  import createControllerWrapper from '@wix/yoshi-flow-editor/runtime/esm/controllerWrapper.js';

  
const wrapController = null;


  
var createHttpClient = null;

  
var initI18n = null;

  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
    DSN: 'https://5605bf8f38c54260af44e1d7bc2450bd@sentry.io/1362236',
    id: 'undefined',
    projectName: 'wixstores-client-product-page',
    teamName: 'wixstores',
    errorMonitor: true,
  };

  var experimentsConfig = {"scopes":["viewer-apps-1380b703-ce81-ff05-f115-39571d94dfcd"],"centralized":true};

  var translationsConfig = {"enabled":false,"icuEnabled":false};

  var biConfig = null;

  var defaultTranslations = null;

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/d7a4e0f42d2e4b8d/packages/wixstores-client-product-page/target/generated/bi/createBILogger.ts';

  const controllerOptions = {
    sentryConfig,
    biConfig,
    fedopsConfig,
    experimentsConfig,
    biLogger,
    translationsConfig,
    persistentAcrossPages: false,
    appName: "Product Page",
    componentName: "ProductPage",
    appDefinitionId: "1380b703-ce81-ff05-f115-39571d94dfcd",
    componentId: "13a94f09-2766-3c40-4a32-8edb5acdd8bc",
    projectName: "wixstores-client-product-page",
    defaultTranslations,
    multilingualDisabled,
    shouldUseEssentials: true,
    withErrorBoundary: false,
    localeDistPath: "assets/locales"
  };

  const _controller = createControllerWrapper(userController, controllerOptions, {
    initI18n,
    createHttpClient,
    createExperiments,
  });

  export const wrap = wrapController;
  export const descriptor = {
    ...controllerOptions,
    id: controllerOptions.componentId,
    widgetType: "WIDGET_OUT_OF_IFRAME",
    controllerFileName: "/home/builduser/work/d7a4e0f42d2e4b8d/packages/wixstores-client-product-page/src/components/ProductPage/controller.ts",
  };

  export const controller = _controller
  export default controller;
